import React, { useState/* , useEffect */ } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from "gatsby"
import { FaSearch } from 'react-icons/fa'
import TextHighlight from './highlight'
import styled from 'styled-components'
// import { Wrapper, ResultWrapper } from './style'

const ResultWrapper = styled.div`
  background: white;
  position: absolute;
  z-index: 10;
  width: 100%;
  box-shadow: -4px 4px 16px -8px black;
  display: none;
  transition: 0.3s;
  &.active {
    display: block;
  }
  p {
    margin: 0px;
    padding: 4px 16px;
    border-bottom: solid 8px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ul {
    margin: 0px;
    padding: 0px 16px;
    overflow-y: scroll;
    max-height: 70vh;
    li {
      list-style: none;
      margin: 16px 0px;
      border-left: solid 8px rgba(0, 0, 0, 0.1);
      padding-left: 16px;
      font-size: 15px;
      a {
        display: block;
        width: 100%;
        background: white;
        text-decoration: none;
        box-shadow: none;
        padding: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
`

const SearchWrapper = styled.div`
  position: relative;
  width: 50%;
  .search-box {
    border: dashed 1px lightgray;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    .search-icon {
      margin-left: 8px;
      color: dimgray;
    }
    input {
      border: none;
      background: none;
      width: calc(100% - 16px);
      padding: 8px;
      padding-left: 14px;
      outline: none;
    }
  }

  /* 参考：https://styled-components.com/docs/faqs#can-i-nest-rules */
  @media(max-width: 600px) {
    width: 100%;
  }
`

const ResultWindow = props => {
  const data = useStaticQuery(graphql`
    query SearchData {
      allMdx(
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 1000
      ) {
        posts: edges {
          post: node {
            fields {
              slug
            }
            frontmatter {
              date(formatString: "YYYY-MM-DD")
              title
              # slug
              tags
              keywords
            }
          }
        }
      }
    }
  `)
  // -

  const value = props.value.toLowerCase()
  const result = data.allMdx.posts.map(({ post }) => {
    return post
  }).filter(({ frontmatter }) => {
    const target = `
      ${frontmatter.title ? frontmatter.title.toLowerCase() : ''}
      ${frontmatter.tags ? frontmatter.tags.join(" ").toLowerCase() : ''}
      ${frontmatter.keywords ? frontmatter.keywords.join(" ").toLowerCase(): ''}
    `
    // console.log(frontmatter)
    return value ? target.match(value) : false
  })

  return (
    <ResultWrapper
      // style={{ display: !props.focus && 'none' }}
      className={ props.focus ? 'active' : '' }
    >
      <p>{ result.length } <small>post{ result.length > 1 ? 's' : '' }</small></p>
      <ul
        style={{ display: !props.value && 'none' }}
      >
        {result.map(post => {
          return (
            <li key={post.fields.slug}>
              <Link to={`${post.fields.slug}`}>
                <TextHighlight
                  str={post.frontmatter.title}
                  includes={props.value}
                />
              </Link>
            </li>
          )
        })}
      </ul>
    </ResultWrapper>
  )
}

const Search = props => {
  const [focus, setFocus] = useState(false)
  const [value, setValue] = useState('')

  // const onFocus = _ => {
  //   setFocus(true)
  // }
  // const onBlur = _ => {
  //   setFocus(false)
  // }

  const onMouseOver = _ => {
    setFocus(true)
  }

  const onMouseOut = _ => {
    setFocus(false)
  }

  const onChange = e => {
    setValue(e.target.value)
  }

  return (
    <SearchWrapper
      onMouseOut={onMouseOut}
      onFocus={ ()=> void 0 }
      onMouseOver={onMouseOver}
      onBlur={ ()=> void 0 }
    >
      <div
        className="search-box"
        style={{ background: focus && 'rgba(0, 0, 0, 0.1)' }}
      >
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search"
          // onFocus={onFocus}
          // onBlur={onBlur}
          onChange={onChange}
          style={{
            fontFamily: value ? '"Avenir Next", "Helvetica Neue", "Segoe UI", "Helvetica", "Arial", "sans-serif"' : '',
          }}
        />
      </div>
      <ResultWindow focus={focus} value={value} />
    </SearchWrapper>
  )
}

export default Search
